// extracted by mini-css-extract-plugin
export default {"header":"ProposalLine_header__zfohT","content":"ProposalLine_content__LhQ9u"};